import axios from '@/services/api'

/**
 * @param {Number} id
 *
 * @returns {Promise<Object>}
 */
export const getRSSPodcasts = (id) => {
    const url = `/api/external-feed?feed_id=${id}&page=1`
    return axios.get(url)
}